import React from 'react';

import {
  HeaderButtonsWrapperDefaultProps,
  HeaderButtonsWrapperPropTypes
} from 'src/components/JobSpellCheckPopup/propTypes';
import { useTranslation } from 'react-i18next';
import s from './JobSpellCheckPopup.styles';

export const HeaderButtonsWrapper = ({
  disabled,
  disabledNext,
  disabledPrevious,
  onSelectNext,
  onSelectPrevious,
}) => {
  const { t } = useTranslation();

  return (
    <s.HeaderButtonsWrapper>
      <s.HeaderButton
        disabled={disabledPrevious || disabled}
        onClick={onSelectPrevious}
        sm
      >
        {t('PREVIOUS')}
      </s.HeaderButton>
      <s.HeaderButton
        disabled={disabledNext || disabled}
        onClick={onSelectNext}
        sm
      >
        {t('NEXT')}
      </s.HeaderButton>
    </s.HeaderButtonsWrapper>
  );
};

HeaderButtonsWrapper.propTypes = HeaderButtonsWrapperPropTypes;
HeaderButtonsWrapper.defaultProps = HeaderButtonsWrapperDefaultProps;
